import { useState } from 'react';

const Tag = ({ label, isSelected, onClick }) => {
    return (
        <button
            className={`px-3 py-2 rounded ${isSelected ? 'bg-tag-purple text-violet-700' : 'bg-white text-zinc-500'} text-xs font-normal hover:bg-zinc-300`}
            onClick={onClick}
        >
            <span className="mr-1">#</span>{label}
        </button>
    );
};

const Tags = () => {
    const [tags, setTags] = useState([
        'Animal',
        'Architecture',
        'Nature',
        'Technology',
        'Fashion',
        'Food',
        'Travel',
        'Art',
        'Photography'
    ]);
    const [selectedTag, setSelectedTag] = useState(null);
    const [customTag, setCustomTag] = useState('');

    const handleTagClick = (tag) => {
        setSelectedTag(tag);
    };

    const handleCustomTagChange = (e) => {
        setCustomTag(e.target.value);
    };

    const handleCustomTagBlur = () => {
        if (customTag.trim()) {
            setTags([...tags, customTag.trim()]);
            setCustomTag('');
        }
    };

    return (
        <div className="w-full max-w-4xl p-4 bg-stone-50 rounded-lg flex flex-col justify-start items-start gap-3">
            <div className="text-zinc-800 text-base font-bold leading-none">Tags</div>
            <div className="flex flex-wrap gap-2">
                {tags.map((tag, index) => (
                    <Tag
                        key={index}
                        label={tag}
                        isSelected={selectedTag === tag}
                        onClick={() => handleTagClick(tag)}
                    />
                ))}
                <input
                    className="px-3 py-2 rounded bg-white text-zinc-500 text-xs font-normal focus:outline-none"
                    placeholder="Add your tag..."
                    value={customTag}
                    onChange={handleCustomTagChange}
                    onBlur={handleCustomTagBlur}
                />
            </div>
        </div>
    );
};

export default Tags;
